const VALID_METHODS = ["GET", "POST", "PUT", "PATCH", "DELETE", "HEAD", "OPTIONS"];
const VALID_MODE = ["enforce", "log"];
const VALID_OP = ["eq", "neq", "prefix", "in"];
const VALID_MISMATCH = ["deny", "log", "next"];

export function validateAuthzPolicyForm(draft = {}, { isNew = true } = {}) {
  const errors = {};
  const rules = Array.isArray(draft.rules) ? draft.rules : [];
  const ruleErrors = rules.map(() => ({}));

  if (isNew) {
    const method = String(draft.method || "").trim();
    if (!method) errors.method = "Method is required";
    else if (!VALID_METHODS.includes(method)) errors.method = "Select a valid method";

    if (!String(draft.path_template || "").trim()) {
      errors.path_template = "Path template is required";
    }
  }

  const mode = String(draft.mode || "").trim();
  if (!mode) errors.mode = "Enforcement mode is required";
  else if (!VALID_MODE.includes(mode)) errors.mode = "Select a valid enforcement mode";

  if (!rules.length) {
    errors.rules = "At least one ownership rule is required";
  }

  rules.forEach((rule, idx) => {
    if (!String(rule.claim || "").trim()) ruleErrors[idx].claim = "JWT claim is required";
    if (!String(rule.param || "").trim()) ruleErrors[idx].param = "Path param is required";

    const op = String(rule.op || "").trim();
    if (!op) ruleErrors[idx].op = "Operator is required";
    else if (!VALID_OP.includes(op)) ruleErrors[idx].op = "Select a valid operator";

    const onMismatch = String(rule.on_mismatch || "").trim();
    if (!onMismatch) ruleErrors[idx].on_mismatch = "On mismatch is required";
    else if (!VALID_MISMATCH.includes(onMismatch)) ruleErrors[idx].on_mismatch = "Select a valid action";
  });

  const hasRuleErrors = ruleErrors.some((row) => Object.keys(row).length > 0);
  return {
    valid: !Object.keys(errors).length && !hasRuleErrors,
    errors,
    ruleErrors,
  };
}
